// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"defaultButton_buttonWrapper__OL9lr"};